import { render, staticRenderFns } from "./exibir-lei-13146-2015.vue?vue&type=template&id=33ccc362&"
import script from "./exibir-lei-13146-2015.vue?vue&type=script&lang=js&"
export * from "./exibir-lei-13146-2015.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ccc362')) {
      api.createRecord('33ccc362', component.options)
    } else {
      api.reload('33ccc362', component.options)
    }
    module.hot.accept("./exibir-lei-13146-2015.vue?vue&type=template&id=33ccc362&", function () {
      api.rerender('33ccc362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/legislacao/exibir-lei-13146-2015.vue"
export default component.exports